import { render, staticRenderFns } from "./OlderDetailAddBase.vue?vue&type=template&id=726dcb36&scoped=true"
import script from "./OlderDetailAddBase.vue?vue&type=script&lang=js"
export * from "./OlderDetailAddBase.vue?vue&type=script&lang=js"
import style0 from "./OlderDetailAddBase.vue?vue&type=style&index=0&id=726dcb36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726dcb36",
  null
  
)

export default component.exports